var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"b-add-worker__wrapper container h-pb-50"},[(_vm.mainRouteGlobal === `/partners-onboarding`)?_c('AppointmentAddPartnerWorker'):_c('AppointmentAddHubBranchAdvisor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }